import type { LockboxCodeType } from "api/landlord/lockboxes";

export const LOCKBOX_CODE_TYPE_LABELS: Record<LockboxCodeType, string> = {
  access: "Access code",
  shackle: "Shackle code"
};
